export enum HeaderFaucetNavigation {
  validate = "validate",
  funded = "funded",
}
